import http from "./http-common";
import SliderModel from "../models/slider";

// Navbar APIs
// eslint-disable-next-line
export default new (class SliderService {
  // Get all members
  async getImage() {
    return await http
      .get("/home-sliders?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((image) => SliderModel.get(image))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
